import type {
  BusinessGetResponseType,
  UserCreateResponseType,
} from "@sellar-io/api-v2/types";
import type { ReactElement } from "react";
import { Navigate, Route } from "react-router";
import * as ROUTES from "../constants/routes";
import type { ExtendedFirebaseUser } from "../contexts/SellarSessionContext";
import { OAuth2SignInPage } from "../pages";
import { FirebaseHandler } from "../pages/auth/firebaseHandler/FirebaseHandler";
import { UserSignupStep } from "../pages/auth/signup/steps/UserSignupStep";
import { VerificationEmailSent } from "../pages/auth/VerificationEmailSent";

/**
 * Authentication route availability depends on partial session state, unlike
 * the authenticated application routes. Keep these transitions together so
 * AppRoutes only composes route groups.
 */
export const renderAuthenticationRoutes = ({
  firebaseUser,
  sellarUser,
  business,
}: {
  firebaseUser: ExtendedFirebaseUser | undefined;
  sellarUser: UserCreateResponseType | null;
  business: BusinessGetResponseType | null;
}): ReactElement => (
  <>
    {(!sellarUser || !business) && (
      <>
        <Route path={ROUTES.SIGNUP} element={<UserSignupStep />} />
        <Route path={ROUTES.FIREBASE_HANDLER} element={<FirebaseHandler />} />
      </>
    )}
    {firebaseUser && !sellarUser && (
      <Route
        path={ROUTES.LOGIN}
        element={<Navigate to={ROUTES.SIGNUP} replace />}
      />
    )}
    {!sellarUser && !firebaseUser && (
      <Route path={ROUTES.LOGIN} element={<UserSignupStep />} />
    )}
    {!firebaseUser?.firebaseUser.emailVerified && (
      <Route
        path={ROUTES.VERIFICATION_EMAIL_SENT}
        element={<VerificationEmailSent />}
      />
    )}
    <Route path={ROUTES.OAUTH_LOGIN} element={<OAuth2SignInPage />} />
  </>
);
